import { createPortal } from "react-dom";
// @ts-expect-error react-lottie has no types
import Lottie from "react-lottie";
import animationData from "../../assets/animation/Loader.json";
import styles from "./styles.module.scss";
import classNames from "classnames";
import QueryInsightsRobot from "@/assets/images/query_insights_robot.png";
import Typewriter from "typewriter-effect";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const Loader = () => {
  const loaderEl = document.getElementById("loader");
  if (!loaderEl) return null;
  return createPortal(
    <div className={styles.container} role="alert" aria-busy="true" aria-label="Loading content">
      <Lottie options={defaultOptions} width={200} height={200} />
    </div>,
    loaderEl
  );
};

interface ComponentLoaderProps {
  top?: number;
  left?: number;
  label?: string;
}

const ComponentLoader = ({ top = 50, left = 50, label }: ComponentLoaderProps) => {
  return (
    <div
      className={styles.component}
      style={{ top: `${top}%`, left: `${left}%` }}
      role="alert"
      aria-busy="true"
      aria-label={label || "Loading content"}
    >
      <Lottie options={defaultOptions} width={200} height={200} />
      {label && <div style={{ marginTop: "-70px" }}>{label}</div>}
    </div>
  );
};

const RelativeComponentLoader = ({
  width = 200,
  height = 200,
  label = "Loading...",
  componentHeight = 100,
  testId = "",
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: `${componentHeight}vh`,
      }}
      role="alert"
      aria-busy="true"
      aria-label={label || "Loading content"}
      data-testid={testId}
    >
      <div style={{ textAlign: "center" }}>
        <Lottie options={defaultOptions} width={width} height={height} />
        {label && <div style={{ marginTop: "-70px" }}>{label}</div>}
      </div>
    </div>
  );
};

interface TypeWriterLoaderProps {
  loadingTexts: string[];
  label?: string;
}

const TypeWriterLoader = ({ loadingTexts, label }: TypeWriterLoaderProps) => {
  return (
    <div
      className={classNames(styles.explanation_popup, styles.generating)}
      role="alert"
      aria-busy="true"
      aria-label={label || "Loading content"}
    >
      <img className={styles.robot_image} src={QueryInsightsRobot} alt="query_insights_robot" />
      <Typewriter
        options={{
          strings: loadingTexts,
          autoStart: true,
          loop: true,
          wrapperClassName: styles.rotating_text,
        }}
      />
      <div className={styles.text}>{label}</div>
    </div>
  );
};

export { Loader, ComponentLoader, RelativeComponentLoader, TypeWriterLoader };
